import { useEffect, useState } from "react";
import Card from "../../../../components/Card";
import Empthy from "../../../../components/Empty";
import Loader from "../../../../components/Loader";
import Modal from "../../../../components/Modal";
import { useUser } from "../../../../context";
import { UseApi } from "../../../../hooks/use-api";

import styles from "./NFTTemplate.module.sass";
import Checkbox from "../../../../components/Checkbox";
import Form from "../../../../components/Form";
import raffle from "../../../../i11/Raffle";
import { GetNFTTemplates } from "../../../../Services/lib/nfttemplates";

const NftTemplatesModal = ({
	isOpen: isOpen_,
	onClose: onClose_,
	filter,
	setFilter,
	setLocal,
}) => {
	const [{ isLoading: busy }, getNFTs] = UseApi({
		service: GetNFTTemplates,
	});
	const { locale } = useUser();
	const [nft, setNft] = useState([]);
	const [selectFilter, setSelectFilter] = useState([]);

	const close = () => {
		const obj = { list: [...selectFilter.map((obj) => obj._id)] };
		const obj2 = {
			list: [
				...selectFilter.map((obj) => {
					return {
						_id: obj._id,
						name: obj.name,
					};
				}),
			],
		};
		let criterians = [];
		let localCri = [];
		setFilter((e) => {
			criterians = e ? [...e, obj2] : [obj2];
			// console.log(e);
			const pushLacal = e
				? [
						...e.map((bfr) => {
							return {
								list: [...bfr.list.map((val) => (val?.name ? val._id : val))],
							};
						}),
				  ]
				: [];
			localCri = e ? [...pushLacal, obj] : [obj];
			console.log(pushLacal);

			return criterians;
		});
		console.log("criterians", criterians);
		console.log("localCri", localCri);
		setLocal((local) => {
			return {
				...local,
				criterians: [...localCri],
			};
		});
		onClose_();
	};
	const handleChange = (item) => {
		if (selectFilter.some((obj) => obj._id === item._id)) {
			setSelectFilter(selectFilter.filter((x) => x._id !== item._id));
		} else {
			setSelectFilter((s) => [item]);
		}
	};

	const [filterNFT, setFilterNFT] = useState({
		offset: 0,
		limit: 20,
		sortBy: "updatedAt",
		orderBy: "desc",
		status: "MINTED",
		name: "",
		nftTypes: [],
	});

	const getNFTs_ = async () => {
		const res = await getNFTs(filterNFT);
		if (res && res?.nftTemplates) {
			setNft(res.nftTemplates);
		}
	};
	useEffect(() => {
		getNFTs_();
	}, [filterNFT]);

	useEffect(() => {
		setSelectFilter([]);
	}, []);

	useEffect(() => {}, [selectFilter, filter]);

	return (
		<>
			<Modal
				outSideClickNone
				outerClassName={styles.outer}
				visible={isOpen_}
				onClose={onClose_}
			>
				<Card
					className={styles.card}
					title={raffle[locale].sel_cr}
					classTitle="title-blue"
					head={
						<>
							<Form
								placeholder={raffle[locale].search}
								type="text"
								name="search"
								icon="search"
								required={false}
								setValue={(val) => {
									setFilterNFT((e) => {
										return { ...e, name: val };
									});
								}}
							/>
						</>
					}
				>
					{busy && (
						<div className={styles.loaderWrap}>
							<Loader />
						</div>
					)}
					<div className={styles.maxHeight}>
						{nft.length !== 0
							? nft.map((e) => {
									return (
										<Row
											getList={() => {}}
											key={e._id}
											data={e}
											value={selectFilter.some((obj) => obj._id === e._id)}
											onChange={() => handleChange(e)}
										/>
									);
							  })
							: !busy && <Empthy />}
					</div>
					<div className={styles.buttonContainer}>
						<button
							onClick={close}
							className="button-small"
							disabled={selectFilter.length === 0}
						>
							{raffle[locale].add}
						</button>
					</div>
				</Card>
			</Modal>
		</>
	);
};

const Row = ({ data, value, onChange }) => {
	return (
		<div className={styles.row}>
			<Checkbox value={value} onChange={onChange} />
			<div className={styles.img}>
				<img src={data.image} alt={"_image"} />
			</div>
			<div>{data.name}</div>
			{/* <div>-</div>
			<div>${data.price}</div> */}
		</div>
	);
};

export default NftTemplatesModal;
